import { Typography} from '@mui/material';


function SearchDistance(props) {
  let { distance, className, style, sx, component, to, color, paragraph} = props;
  const display= (distance / 1609).toFixed() + " miles";

  
  return (
	
		  <Typography
	              sx={sx}
	              className={className}
	              style={style}
	              component={component}
	              to={to}
	              color={color}
	              paragraph={paragraph}
	            >
	              {display} 
	      </Typography> 
	      
  );
  
}


export default SearchDistance;